<template>
  <SpinnerComponent :start="isLoading" />
  <div class="p--home">

    <swiper v-if="isAds" :slides-per-view="1" :space-between="50" :autoplay="{delay: 3500, disableOnInteraction: false}" :modules="modules" class="box-ads-swiper">
      <swiper-slide v-for="a in ads" :key="a" class="item-ads-swiper">
        <img alt="default" :src="a['Image']">
      </swiper-slide>
    </swiper>

    <div class="box-marquee" v-if="isNews">
      <marquee direction="right">
        <span class="text" v-for="n in news" :key="n">{{ n.Details }} <span class="m"></span></span>
      </marquee>
    </div>

    <div class="content-items" v-if="isCategoriesParent">

      <div class="item" v-for="x in categoriesParent" :key="x" @click="goCategore(x.ID)">
        <a href="#" class="card-populer">
          <div class="card-populer-content" :style="{ backgroundImage: `url(${x.Image})` }" style="transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px);">
            <div class="card-populer-img">
              <img :src="x.Image">
            </div>
            <div class="card-populer-text">
              <span>{{ x.Name }}</span>
              <h1>{{ x.Details }}</h1>
            </div>
            <div class="mask"></div>
          </div>
        </a>
      </div>

    </div>

    <div class="content-categories" v-if="defaultHome != 'categories'">

      <div class="box-search" v-if="isCategories">
        <input class="search-input" type="search" :placeholder="$t('_public._search')" @input="filter($event)">
      </div>
      
      <div class="content-category" v-if="isCategories">
        <!-- <div class="item-category" v-for="x in 100" :key="x" @click="say(x)"> -->
        <div class="item-category" v-for="x in categories" :key="x" @click="say(x)" :class="x['ribbon_text']">
          
          <!-- offer rise not-available -->
          <!-- <div v-if="x['ribbon_item'] !== 'no'" class="card-ribbon" :class="x['ribbon_item']">
            <span>{{ x['ribbon_text'] }}</span>
          </div> -->

          <img class="category-img" alt="Vue logo" :src="x.Logo">
          <h3 class="category-name">{{ x.Name }}</h3>
        </div>
      </div>

      <div class="content-empty-items" v-if="!isCategories">
        <div><ion-icon name="cloud-offline-outline"></ion-icon></div>
        <p class="products-name">{{ $t('_public._there_are_no_data') }}</p>
      </div>

    </div>

  </div>

</template>

<script>
import SpinnerComponent from '@/components/SpinnerComponent.vue';

import axios from 'axios';
import router from "@/router";

import { Swiper, SwiperSlide } from 'swiper/vue';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import myUser, { _changLocalUser } from '../myUser'
import { routerVisitor } from '../auth'
import { showBtnSidebar, showNavigation } from '@/components/sidebar-new/state';
import Swal from 'sweetalert2'
// import { toast } from "vue3-toastify";
// import 'vue3-toastify/dist/index.css'

import { _changeSwitchLang } from '../i18u';

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
    SpinnerComponent,
    Swiper,
    SwiperSlide
  },
  data() {
    
    return {
      lang: this.$i18n.locale,
      isLogin: myUser.isLogin,
      isLoading: true,
      defaultHome: 'categories',
      categoriesParent: null,
      isCategoriesParent: false,
      categories: [],
      b_categories: [],
      isCategories: false,

      ads: null,
      isAds: false,
      swiper: null,

      news: null,
      isNews: false
    }
  },
  methods: {
    async checkLogin() {
      console.log('ddddddd')
      const check = routerVisitor();
      if(check == 'yes'){
        this.getDataView()
      }

    },
    async getDataView(){
      this.getGeneralSettings();
      // this.getAllCategoriesParent();
      // this.getAllCategories();
      this.getAllViewAds();
      this.getAllViewNews();
      this.checkMaintenance();
      this.getVersionApp();

      if(myUser.isLogin == 'yes'){
        this.getAllMessagesPop();
        this.getExchangeRates();
        this.matchingPriceGroups() 
      }
  
    },
    async getGeneralSettings(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('app_settings.php?action=getGeneralSettings', inputs).then((res) => {
        console.log(res['data'])
        if (res['data']['msg'] == 'ok') {
          const defaultLanguage = res?.data?.Default_Language && res.data.Default_Language.trim() !== "" ? res.data.Default_Language : "en";
          const darkMode = res?.data?.Dark_Mode && res.data.Dark_Mode.trim() !== "" ? res.data.Dark_Mode : "true";
          this.defaultHome = res?.data?.Default_Home && res.data.Default_Home.trim() !== "" ? res.data.Default_Home : "sections";
          console.log(darkMode, defaultLanguage);
          this.switchTheme(darkMode);
          this.changeSwitchLang(defaultLanguage);
          if(this.defaultHome == 'categories'){
            this.getAllCategoriesParent();
          } else {
            this.getAllCategories();
          }
          // console.log(res['data']['items'])

          this.isLoading = false;

        } else {

          console.log(res['data']['msg']);
          this.isLoading = false;
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
    async switchTheme(darkMode) {
      // localStorage.removeItem("DARK_MODE_HUAWEICASH");

      let currentMode = localStorage.getItem("DARK_MODE_HUAWEICASH");

      // إذا لم تكن هناك قيمة محفوظة استخدم قيمة المتغير
      if (!currentMode) {
        currentMode = darkMode === 'true' ? 'dark' : 'light';
        localStorage.setItem("DARK_MODE_HUAWEICASH", currentMode);
      }

      const bodyPage = document.body;
      const iconTheme = document.getElementById("we-icon-theme");
      const metaTheme = document.querySelector('meta[name="theme-color"]');

      if (currentMode === 'dark') {
        bodyPage.classList.add("dark-theme");
        iconTheme?.setAttribute("name", "sunny-outline");
        metaTheme?.setAttribute("content", "#121212");
      } else {
        bodyPage.classList.remove("dark-theme");
        iconTheme?.setAttribute("name", "moon-outline");
        metaTheme?.setAttribute("content", "#d81e25");
      }
    },
    async changeSwitchLang(lang){
      // localStorage.removeItem("MY_LANG_HUAWEICASH");
      
      let currentLang = localStorage.getItem("MY_LANG_HUAWEICASH");
      if (!currentLang) {
        _changeSwitchLang(lang);
      }

      console.log(lang)
      console.log(currentLang)
    },
    async getAllCategoriesParent(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('categories.php?action=getAllCategoriesParent', inputs).then((res) => {
        console.log(res['data'])
        if (res['data']['msg'] == 'ok') {
          // console.log(res)
          // console.log(res['data']['items'])
          this.categoriesParent = res['data']['items'];
          this.isCategoriesParent = true;
          this.isLoading = false;

        } else {
          this.isCategoriesParent = false;
          // console.log(res['data']['msg']);
          this.isLoading = false;
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
    async getAllCategories(){
      // this.isLoading = false;

      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token, 'idCatParent': this.$route.params.id} 
      await axios.postForm('categories.php?action=getAllCategories', inputs).then((res) => {
        // console.log(res['data'])
        if (res['data']['msg'] == 'ok') {
          // console.log(res)
          // console.log(res['data']['items'])
          this.categories   = res['data']['items'];
          this.b_categories = res['data']['items'];
          this.isCategories = true;
          this.isLoading = false

        } else {
          this.categories   = [];
          this.b_categories = [];
          this.isCategories = false;
          // console.log(res['data']['msg']);
          this.isLoading = false
        }
      }).catch(() => {
        // console.error('Login request error:', error);
        // console.error('Login request error:');
        _changLocalUser("isDisconnect", "network")
      });
    },
    async getAllViewAds(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('ads.php?action=getAllViewAds', inputs).then((res) => {
        // console.log("getAllViewNews", res['data'])
        if (res['data']['msg'] == 'ok') {
          // console.log(res)
          // console.log(res['data']['items'])
          this.ads     = res['data']['ads'];
          this.isAds   = true;
          this.isLoading= false;

        } else {
          this.isAds = false;
          // console.log(res['data']['msg']);
          this.isLoading = false;
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
    async getAllViewNews(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('ads.php?action=getAllViewNews', inputs).then((res) => {
        // console.log("getAllViewNews", res['data'])
        if (res['data']['msg'] == 'ok') {
          // console.log(res)
          // console.log(res['data']['items'])
          this.news     = res['data']['ads'];
          this.isNews   = true;
          this.isLoading= false;

        } else {
          this.isNews = false;
          // console.log(res['data']['msg']);
          this.isLoading = false;
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
    async getAllMessagesPop(){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('messages.php?action=getAllMessagesPop', inputs).then((res) => {
        // console.log("getAllMessagesPop", res['data'])
        if (res['data']['msg'] == 'ok') {
          res['data']['items'].forEach(pop => {
            let id_message  = pop['ID'];
            let title       = pop['Title'];
            let message     = pop['Message'];
            // let in_image  = pop['in_Image'];
            let image       = pop['Image'];

            this.viewPop(id_message, title, message, image)

          });


        } else {
          // console.log(res['data']['msg']);
        }
      }).catch(() => { _changLocalUser("isDisconnect", "network") });
    },
    async viewPop(id_message, title, text, imageUrl){
      Swal.fire({
        title: title, //'Sweet!',
        text: text, //'Modal with a custom image.',
        imageUrl: imageUrl, //'https://unsplash.it/400/200',
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: 'Custom image',
        showClass: {
          popup: 'messages__pop'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log("viewPop")
          this.readMessagesPop(id_message);
        }
      })
    },
    async readMessagesPop(id_message){
      // this.isLoading = false;
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token, 'id_message': id_message} 
      await axios.postForm('messages.php?action=readMessagesPop', inputs).then((res) => {
        console.log("readMessagesPop", res['data'])
      }).catch(() => { 
        //_changLocalUser("isDisconnect", "network") 
      });
    },
    async checkMaintenance(){
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('app_settings.php?action=checkMaintenance', inputs).then((res) => {
        // console.log("getAllMessagesPop", res['data'])
        if (res['data']['msg'] == 'ok') {

          _changLocalUser("isDisconnect", "maintenance");
          
        }
      }).catch(() => { 
        //_changLocalUser("isDisconnect", "network") 
      });

    },
    async getVersionApp() {
      let app_ver   = this.$t('_public._app_ver');
      const inputs  = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token, 'ver': app_ver} 
      await axios.postForm('app_settings.php?action=getVersionAppNew', inputs).then((res) => {
        // console.log("getAllMessagesPop", res['data'])
        if (res['data']['status'] == 'update') {
          _changLocalUser("isDisconnect", "update");
          // router.push({ path: `/disconnect/update` });
        }

      }).catch(() => { 
        //_changLocalUser("isDisconnect", "network") 
      });
    },
    async getExchangeRates(){
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('exchange_rates.php?action=getExchangeRates', inputs).then(() => {
        // console.log("getExchangeRates", res['data'])
      }).catch(() => { 
        //_changLocalUser("isDisconnect", "network") 
      });
    },
    async matchingPriceGroups(){
      const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('price_groups.php?action=matchingPriceGroups', inputs).then(() => {
        // console.log("matchingPriceGroups", res['data'])
      }).catch(() => { 
        //_changLocalUser("isDisconnect", "network") 
      });
    },
    // async getAllCategories(){
    //   // this.isLoading = false;
    //   const inputs = {'lang': this.lang, 'idus': myUser.id_user, 'token': myUser.token} 
    //   await axios.postForm('categories.php?action=getAllCategories', inputs).then((res) => {
    //     console.log(res['data'])
    //     if (res['data']['msg'] == 'ok') {
    //       // console.log(res)
    //       console.log(res['data']['items'])
    //       this.categories = res['data']['items'];
    //       this.isCategories = true;

    //     } else {
    //       this.isCategories = false;
    //       console.log(res['data']['msg']);
    //       // this.isLoading = true
    //     }
    //   }).catch(() => {  });
    // },
    async goToPage(page){
      // console.log(page);
      router.push({ path: `/${page}` })
    },
    filter (eve){
      let text = eve.target.value;
      this.categories = this.b_categories;

      if(text.length & this.categories.length){
        // console.log(eve.target.value)
        const n_categories = this.categories.filter((item) =>
          item.Name.toLowerCase().includes(eve.target.value.toLowerCase().split(" "))
        );
        // console.log(n_categories)
        this.categories = n_categories;

      } else {
        return this.categories;
      }
    }
  },
  mounted(){
    showBtnSidebar()
    showNavigation()
    router.replace()
    this.checkLogin()

  },
  setup() {
    const goCategore = (categor_id) => {
      router.push({ path: `/categories/${categor_id}` })
    }

    const say = (item) => {
      const iditem = item['ID'];
      // router.push({ path: `/categories/${iditem}` })
      router.push({ path: `/items/${iditem}` })
    }

    const goCurrencyMovement = (item) => {
      const currency_id = item['id'];
      // router.push({ path: `/categories/${iditem}` })
      router.push({ path: `/currency-movement/${currency_id}` })
    }

    return {
      goCategore,
      say,
      goCurrencyMovement,
      modules: [Autoplay, Pagination, Navigation],
    };
  },
}
</script>
<style>
.box-ads-swiper {
  border-radius: 9px;
  margin: 26px 26px;
}
.box-ads-swiper .item-ads-swiper {
  border-radius: 9px;
}
.box-ads-swiper .item-ads-swiper img {
  max-height: 300px;
  width: 100%;
  border-radius: 9px;
}
.box-marquee {
  background: var(--box-background);
  margin: 12px 26px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  box-shadow: 12px 5px 12px rgba(var(--color-box-shadow-rgb), 0.05);
  min-height: 46px;
}
.box-marquee marquee {
  direction: initial;
}
.box-marquee marquee .text .m {
  padding: 0px 12px;
}

.content-categories {
  padding: 0px 26px ;
}


.content-items {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
  margin: 26px;
}
.content-items .item {
  width: 49%;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .content-categories {
    padding: 0px;
  }
  .box-ads-swiper {
    margin: 16px;
  }
  .box-marquee {
    margin: 0px 16px;
    min-height: 34px;
  }
  .box-marquee .text {
    font-size: 13px;
  }
  .content-items {
    margin: 16px;
  }
  .content-items .item {
    width: 100%;
  }
  .box-img-bros {
    width: 80%;
    margin: 0px 10%;
  }
}





.card-populer {
  border: 2px solid transparent;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  border-radius: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  position: relative;
  transition: all ease-in 0.1s;
}

.card-populer:hover {
  transition: all ease-in 0.1s;
  border: 2px solid var(--public);
}

.card-populer::before {
  position: absolute;
  content: "";
  width: 60px;
  height: 1400%;
  background-color: transparent;
  animation: animatepop 4s linear infinite;
}
.card-populer:hover::before {
  background-color: var(--public);
}

[data-theme="dark"] .card-populer:hover::before {
  background-color: #fff;
}

.card-populer::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background-color: #14192b;
  border-radius: 10px;
  overflow: hidden;
}

.card-populer:hover::after {
  width: calc(100% - 5px);
  height: calc(100% - 5px);
}

@keyframes animatepop {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.card-populer-content {
  position: relative;
  z-index: 10;
  color: aliceblue;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-position: top;
  background-position-y: 10%;
  background-size: cover;
  overflow: hidden;
  transition: all ease-out 0.1s;
}

.card-populer-content .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #14192b;
  opacity: 0.5;
  transition: all ease-out 0.3s;
  top: 0;
  left: 0;
  z-index: 1;
}

.card-populer:hover .card-populer-content .mask {
  opacity: 0.5;
  transition: all ease-out 0.3s;
}

.card-populer-text {
  display: flex;
  justify-content: center;
  align-items: start;
  text-align: start;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 2;
  transition: all ease-out 0.3s;
  flex-grow: 1;
  padding-right: 4px;
}

.card-populer:hover .card-populer-text {
  display: flex;
  justify-content: center;
  align-items: start;
  text-align: start;
  transition: all ease-out 0.3s;
  padding-right: 4px;
}

.card-populer-img {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  position: relative;
  z-index: 20;
  transition: all ease-out 0.3s;
}

.card-populer-img img {
  border-radius: 10px;
  height: calc(100% - 30px);
  aspect-ratio: 1/1;
  /* border: 1px solid #fff; */
  transition: all ease-out 0.3s;
}

.card-populer:hover .card-populer-img {
  /* padding: 0px 20px; */
  transition: all ease-out 0.3s;
}

.card-populer:hover .card-populer-img img {
  height: calc(100% - 30px);
  transition: all ease-out 0.3s;
}

.card-populer-content {
  display: flex;
  align-items: center;
}

.card-populer:hover .card-populer-content {
  width: calc(100% - 5px);
  height: calc(100% - 5px);
  transition: all ease-out 0.1s;
  position: relative;
}

.card-populer-content h1 {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  text-shadow: 1px 1px 4px #14192b;
}

.card-populer:hover .card-populer-content h1 {
  font-size: 16px;
}

.card-populer-content span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 1px 1px 4px #14192b;
  text-align: start;
}

@media (max-width: 756px) {
  .card-populer-content h1 {
    font-size: 12px;
    /* text-align: start; */
  }

  .card-populer:hover .card-populer-content h1 {
    font-size: 14px;
    /* text-align: start; */
  }

  .card-populer-content span {
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .card-populer-content h1 {
    font-size: 0.625rem;
    /* text-align: start; */
  }

  .card-populer:hover .card-populer-content h1 {
    font-size: 12px;
    text-align: start;
  }

  .card-populer-content span {
    font-size: 10px;
  }

  .card-populer {
    height: 80px;
  }

  .card-populer:hover .card-populer-img img {
    height: calc(100% - 30px);
  }

  .card-populer .card-populer-img {
    padding: 0px 10px;
  }

  .card-populer-img img {
    border-radius: 10px;
  }
}

.card-populer {
  transform-style: preserve-3d;
  perspective: 1000px;
  transition: transform 0.1s ease;
}

.card-populer:hover {
  transform: translateY(-5px);
}

.card-populer-content {
  transform-style: preserve-3d;
  transition: transform 0.1s ease;
}

.card-populer-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transform: skewX(-25deg);
  z-index: 3;
  pointer-events: none;
}

.card-populer:hover .card-populer-content::before {
  animation: shine 0.8s ease-in-out;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 150%;
  }
}

.card-populer-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at var(--mouse-x, 50%) var(--mouse-y, 0%),
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.card-populer:hover .card-populer-content::after {
  opacity: 1;
}

.card-populer-img::after {
  content: "";
  position: absolute;
  top: 10%;
  right: 10%;
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
  opacity: 0;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.8),
    0 0 20px rgba(255, 255, 255, 0.6),
    0 0 30px rgba(255, 255, 255, 0.4);
  z-index: 25;
}

.card-populer:hover .card-populer-img::after {
  animation: sparkle 1.5s ease-in-out infinite;
}

@keyframes sparkle {
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}

.card-populer:hover {
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(255, 215, 0, 0.2);
}
/* ====> START Screen Phone <====*/
@media (min-width: 1px) {
  .content-products .item-products {
    width: calc(92% / 3);
    margin-bottom: 3%;
  }
}
@media (max-width: 599px) {
  .p--home .content-category .item-category {
    width: calc(92% / 3);
    margin-bottom: 3%;
  }
}
@media (min-width: 600px) {
  .p--home .content-category .item-category {
    width: calc(92% / 3);
  }
}
@media (min-width: 768px) {
  .p--home .content-category .item-category {
    width: calc(92% / 4);
  }
  .content-header-amount .countent-btns {
    justify-content: space-evenly;
  }
}
@media (min-width: 992px) {
  .p--home .content-category .item-category {
    width: calc(92% / 4);
  }
}
@media (min-width: 1200px) {
  .p--home .content-category .item-category {
    width: calc(92% / 5);
  }
}
/* ====> END Screen Phone <====*/
</style>
